import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function unCheckedTask(task: Identifiable<Task>, nextTask: Identifiable<Task>) {
  return (
    (task.percentComplete === 100 && nextTask.percentComplete === 0) ||
    (task.status.percentComplete === 100 &&
      nextTask.status.percentComplete !== 100)
  );
}

function editTask(
  task: Identifiable<Task>,
  nextTask: Task,
): Identifiable<Task> {
  const mergedTask = {
    ...task,
    name: nextTask.name,
    description: nextTask.description,
    startDate: nextTask.startDate,
    endDate: nextTask.endDate,
    createdDate: nextTask.createdDate,
    completionDate: nextTask.completionDate,
    percentComplete: nextTask.percentComplete,
    status: nextTask.status,
    tags: nextTask.tags,
    activityKeyRank: nextTask.activityKeyRank,
    statusKeyRank: nextTask.statusKeyRank,
  };

  return !unCheckedTask(task, mergedTask)
    ? mergedTask
    : {
        ...task,
        ...mergedTask,
        allocations: task.allocations.map((allocation) => ({
          ...allocation,
          percentComplete: 0,
        })),
      };
}

function handleMilestoneEditSuccess(
  task: Identifiable<Task>,
  { impactedElements }: Boundaries["editMilestone"]["success"],
): Identifiable<Task> {
  const impactedTask = impactedElements
    ? impactedElements.find(({ uuid }) => uuid === task.uuid)
    : undefined;

  return !!impactedTask
    ? calculateAdvancement(editTask(task, { ...task, ...impactedTask }))
    : task;
}

export { handleMilestoneEditSuccess };
